var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12c0 .5-.5 1-1 1H4.4l2.3 2.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-4-4c-.4-.4-.4-1 0-1.4l4-4c.2-.2.4-.3.7-.3s.5.1.7.3c.4.4.4 1 0 1.4L4.4 11H18c.5 0 1 .5 1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23c-1.9 0-3.8-.5-5.5-1.5-.5-.3-.6-.9-.4-1.4.3-.5.9-.6 1.4-.4 1.4.9 2.9 1.3 4.5 1.3 5 0 9-4 9-9s-4-9-9-9c-1.6 0-3.1.4-4.5 1.2-.5.3-1.1.1-1.4-.4-.2-.4-.1-1.1.4-1.3C8.2 1.5 10.1 1 12 1c6.1 0 11 4.9 11 11s-4.9 11-11 11z",
    fill: "#050505"
  })));
}

export default SvgIconLogout;